<template>
    <div
        class="international-tel-input-wrapper"
        :style="{ width: `${width}px` }"
        :class="{ focus: isFocus }"
    >
        <v-input
            v-model="number"
            class="international-tel-input"
            kind="simpler"
            :disabled="disabled"
            :placeholder="placeholder"
            :autofocus="autofocus"
            @focus="[(isFocus = true), $emit('focus')]"
            @blur="[(isFocus = false), $emit('blur')]"
        />
    </div>
</template>

<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        autofocus: {
            type: Boolean,
            default: false,
        },
        width: {
            type: [String, Number],
            default: '300',
        },
        value: {
            type: String,
            required: true,
        },
        placeholder: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            number: this.value,
            isFocus: false,
        };
    },
    watch: {
        number: {
            handler(newValue) {
                this.$emit('input', newValue);
            },
            immediate: true,
        },
    },
    mounted() {},
    methods: {
        isValid(inputTel) {
            const tel = inputTel || this.number;
            return /^1(?:\d){10}$/.test(tel);
        },
        getTel() {
            return this.number;
        },
    },
};
</script>

<style lang="less">
/* stylelint-disable declaration-no-important, number-leading-zero */
.international-tel-input-wrapper {
    display: flex;
    border-bottom: 1px solid #dadee7;
    transition: border-color 0.25s;
    box-sizing: border-box;
    height: 40px;

    &.focus {
        border-width: 2px;
        border-color: #0067ed;
    }
    .international-tel-input {
        border: 0;
        width: auto;
        flex: auto;

        .v-input--simpler__placeholder {
            left: 15px;
            text-align: left;
        }
    }
}
</style>
